<template>
  <div>
    <div
      class="modal animated fadeIn"
      tabindex="-1"
      id="new-occupation"
      role="dialog"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
          <div class="modal-body">
            <fieldset class="border p-3">
              <legend>
                <small style="font-size: 15px; font-weight: bold"
                  >new occupation</small
                >
              </legend>
              <form @submit.prevent="newOccupation()">
                <div class="row">
                  <div class="col-md-12">
                    <div class="form-group">
                      <label>Occupation name</label>
                      <input
                        type="text"
                        class="form-control occupation_name"
                        placeholder="occupation name"
                        required
                      />
                    </div>
                  </div>
                </div>
                <button
                  type="submit"
                  class="btn btn-primary btn-flat creatingOcupation"
                >
                  <i class="fa fa-plus"></i> Add occupation
                </button>
                <button
                  type="button"
                  class="btn btn-primary btn-flat creatingOcupationLoader"
                >
                  <span
                    class="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  <i class="fa fa-spinner fa-spin" style="font-size: 24px"></i>
                  please wait...
                </button>
              </form>
            </fieldset>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal animated fadeIn"
      tabindex="-1"
      id="update-occupation"
      role="dialog"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
          <div class="modal-body">
            <fieldset class="border p-3">
              <legend>
                <small style="font-size: 15px; font-weight: bold"
                  >update occupation</small
                >
              </legend>
              <form @submit.prevent="updateOccupation()">
                <div class="row">
                  <input type="hidden" class="id" :value="Occupation.id" />
                  <div class="col-md-12">
                    <div class="form-group">
                      <label>Occupation name</label>
                      <input
                        type="text"
                        class="form-control Uoccupation_name"
                        placeholder="occupation name"
                        :value="Occupation.occupation_name"
                        required
                      />
                    </div>
                  </div>
                </div>
                <button
                  type="submit"
                  class="btn btn-primary btn-flat updatingOccupation"
                >
                  <i class="fa fa-plus"></i> Add occupation
                </button>
                <button
                  type="button"
                  class="btn btn-primary btn-flat updatingOccupationLoader"
                >
                  <span
                    class="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  <i class="fa fa-spinner fa-spin" style="font-size: 24px"></i>
                  please wait...
                </button>
              </form>
            </fieldset>
          </div>
        </div>
      </div>
    </div>
    <fieldset class="border p-3">
      <legend class="auto-wp">
        <small style="font-size: 15px; font-weight: bold"
          >Manage occupations</small
        >
      </legend>
      <button
        type="button"
        class="btn btn-primary btn-roundec"
        data-toggle="modal"
        data-target="#new-occupation"
      >
        <i class="fa fa-plus"></i> new occupation
      </button>
      <p></p>
      <div></div>
      <div class="occupationLoader">
        <span
          class="spinner-border spinner-border-sm"
          role="status"
          aria-hidden="true"
        ></span>
        <i class="fa fa-spinner fa-spin"></i>loading occupations...
      </div>
      <vue-good-table
        :columns="columns"
        :rows="systemOccupations"
        :fixed-header="true"
        :pagination-options="{
          enabled: true,
          mode: 'records',
          perPage: 6,
          position: 'bottom',
          perPageDropdown: [3, 7, 9],
          dropdownAllowAll: false,
          setCurrentPage: 1,
          nextLabel: 'next',
          prevLabel: 'prev',
          rowsPerPageLabel: 'rows per page',
          ofLabel: 'of',
          pageLabel: 'page', //for 'pages' mode
          allLabel: 'all',
        }"
      >
        <template slot="table-row" slot-scope="props">
          <span v-if="props.column.field == 'Action'">
            <button
              class="btn btn-info btn-sm btn-block"
              @click="viewOccupation(props.row.id)"
            >
              <i class="fa fa-edit"></i> Edit occupation
            </button>
          </span>
        </template>
      </vue-good-table>
    </fieldset>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      columns: [
        {
          label: "Occupation name",
          field: "occupation_name",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter consignee name",
          },
        },
        {
          label: "Action",
          field: "Action",
          width: "122px",
          filterOptions: {
            enabled: true, // enable filter for this column
          },
        },
      ],
    };
  },
  created() {
    this.loadOccupations();
  },
  computed: {
    ...mapGetters(["systemOccupations", "Occupation"]),
  },
  methods: {
    ...mapActions([
      "loadOccupations",
      "newOccupation",
      "viewOccupation",
      "updateOccupation",
    ]),
  },
};
</script>
<style scoped>
.creatingOcupationLoader {
  display: none;
}
.updatingOccupationLoader{
    display: none;
}
</style>


// WEBPACK FOOTER //
// src/occupations/manageoccupations.vue